export default {"src":"/_next/static/media/icon-info.5c349f19.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};